import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const ventajas = [
  {
    icon: "ri-hammer-line",
    title: "Durabilidad",
    desc: "Hasta 30 años de vida útil con un mantenimiento mínimo. Resistente a golpes, viento y sol.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Seguridad",
    desc: "Lamas de aluminio anti-intrusión. Difícil de forzar y actúa como barrera física efectiva.",
  },
  {
    icon: "ri-temp-hot-line",
    title: "Aislamiento",
    desc: "Excelente aislamiento térmico y acústico. Mantiene el calor fuera en verano y dentro en invierno.",
  },
  {
    icon: "ri-brush-line",
    title: "Mantenimiento bajo",
    desc: "Solo necesita limpieza ocasional con agua y jabón. No se pudre ni se deforma con la humedad.",
  },
];

const tipos = [
  {
    title: "Mini (lamas 37mm)",
    desc: "Ideal para ventanas pequeñas y huecos estrechos. Ligero y discreto.",
    uso: "Ventanas de baño, cocina, dormitorios pequeños",
  },
  {
    title: "Midi (lamas 45mm)",
    desc: "El estándar más popular. Equilibrio perfecto entre resistencia y estética.",
    uso: "Ventanas estándar de viviendas y oficinas",
  },
  {
    title: "Maxi (lamas 55mm)",
    desc: "Para grandes huecos y puertas. Máxima resistencia y aislamiento.",
    uso: "Puertas terraza, grandes ventanales, locales comerciales",
  },
];

const colores = [
  { name: "Blanco", class: "bg-white border-2 border-slate-200" },
  { name: "Marrón", class: "bg-amber-800" },
  { name: "Gris", class: "bg-slate-500" },
  { name: "Madera", class: "bg-amber-700" },
  { name: "RAL custom", class: "bg-gradient-to-br from-slate-400 to-slate-600" },
];

const faqs = [
  {
    q: "¿Cuánto cuesta una persiana de aluminio en Málaga?",
    a: "Una persiana de aluminio nueva e instalada suele costar entre 180 y 350 € según tamaño y tipo de lamas. Para reparaciones, cambiar lamas cuesta desde 15 € por lama y motorizar desde 200 €.",
  },
  {
    q: "¿Es mejor aluminio o PVC?",
    a: "El aluminio es más resistente y duradero (25-30 años), ideal para seguridad. El PVC es más económico y aísla mejor térmicamente. Te asesoramos gratis según tu necesidad.",
  },
  {
    q: "¿Se puede motorizar una persiana de aluminio?",
    a: "Sí, casi todas las persianas de aluminio se pueden motorizar. Solo necesitamos que el cajón tenga espacio suficiente para el motor tubular. La visita es gratuita.",
  },
  {
    q: "¿Cuánto dura una persiana de aluminio?",
    a: "Con un mantenimiento básico, una persiana de aluminio de calidad dura entre 25 y 30 años. Las lamas no se oxidan ni se deforman con el clima mediterráneo de Málaga.",
  },
  {
    q: "¿Hacéis instalación en comunidades?",
    a: "Sí, instalamos y reparamos persianas de aluminio en comunidades de vecinos, edificios de apartamentos y locales comerciales en toda la Costa del Sol.",
  },
];

export default function PersianasAluminio() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Persianas de Aluminio Málaga | Instalación y Reparación"
        description="Persianas de aluminio en Málaga: resistentes, duraderas, seguras. Instalación y reparación con garantía 2 años. ☎ 951 12 07 70"
        canonical="/persianas/persianas-aluminio/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Persianas", path: "/persianas" }, { name: "Persianas de aluminio" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[60%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> 24h · Respuesta en 20 min
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Persianas de Aluminio en Málaga
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Resistentes, duraderas y seguras. Instalamos y reparamos persianas de aluminio de todas las marcas.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> +10 años · desde 2015</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Seguro RC</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 2 años</span>
                </div>
              </div>
              <div className="w-full lg:w-[40%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1631084650668-5e1f72bf6ce5?w=1200&q=80&auto=format&fit=crop"
                    alt="Persianas de aluminio en Málaga - instalación profesional"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* VENTAJAS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Ventajas del aluminio</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {ventajas.map((v, i) => (
                <motion.div
                  key={v.title}
                  className="bg-white rounded-[20px] p-8 border-t-[6px] border-primary shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${v.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{v.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{v.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* TIPOS */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Tipos disponibles</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {tipos.map((t, i) => (
                <motion.div
                  key={t.title}
                  className="bg-surface-alt rounded-[20px] p-8 hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{t.title}</h3>
                  <p className="font-body text-sm text-text-secondary mb-4 leading-relaxed">{t.desc}</p>
                  <div className="inline-block bg-primary/10 text-primary font-body font-semibold text-xs px-3 py-1.5 rounded-pill">
                    {t.uso}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* COLORES + MANTENIMIENTO */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
              {/* Colores */}
              <div>
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Colores y acabados</h2>
                <p className="font-body text-lg text-text-secondary mb-6">
                  Elige el acabado que mejor combine con tu fachada o interior. También disponible en RAL a medida.
                </p>
                <div className="flex flex-wrap gap-4">
                  {colores.map((c, i) => (
                    <motion.div
                      key={c.name}
                      className="flex flex-col items-center gap-2"
                      initial={{ opacity: 0, scale: 0.9 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: i * 0.06 }}
                    >
                      <div className={`w-14 h-14 rounded-full ${c.class} shadow-sm`}></div>
                      <span className="font-body text-sm text-text-secondary">{c.name}</span>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Mantenimiento */}
              <div className="bg-white rounded-3xl p-8 shadow-sm">
                <h3 className="font-heading font-bold text-2xl text-text-primary mb-4">Mantenimiento básico</h3>
                <p className="font-body text-base text-text-secondary mb-6">
                  El aluminio prácticamente no necesita mantenimiento, pero estos cuidados alargan su vida útil:
                </p>
                <ul className="flex flex-col gap-3">
                  {[
                    "Limpia con agua y jabón neutro cada 3-6 meses",
                    "Lubrica las guías anualmente con silicona en spray",
                    "Revisa que la cinta no esté desgastada",
                    "Comprueba que el recogedor funcione suavemente",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="flex items-center justify-center w-6 h-6 bg-primary/10 text-primary rounded-full shrink-0 text-xs font-bold mt-0.5">{i + 1}</span>
                      <span className="font-body text-sm text-text-secondary">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto" itemScope itemType="https://schema.org/FAQPage">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Preguntas frecuentes sobre persianas de aluminio</h2>
              <div className="flex flex-col gap-4">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-surface-alt rounded-2xl p-6"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}